// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3IhT1","coll-logo":"coll-logo__2yYNq"};